import { motion } from 'framer-motion';
import { observer } from "mobx-react";
import studioStore from '@/stores/studioStore';

const VariationToggle = observer(({
  variations,
  selectedVariation,
  setSelectedVariation,
  layout = "normal",
  isMobile,
  isModal = false,
}) => {
  const isCompact = layout === "compact";

  return (
    <div className={`variation-toggle ${isCompact ? 'p-0 w-[7rem]' : 'w-full md:w-auto p-0 pt-0 md:p-5 md:pt-0 md:pb-6'}`}>
      <div className={`toggle-wrapper flex-1 cursor-pointer items-center overflow-hidden rounded-2xl border font-semibold ${isCompact || isModal || isMobile ? 'border-color-secondary-text-studio' : 'border-white'}`}>
        {variations.filter(variation => variation.status === 'publish').map((variation) => (
          <motion.button
            key={variation.id}
            className={`w-2/4 px-1 rounded-lg ${isMobile ? `text-xs py-1.5` : `text-sm py-[0.3rem]`}
              ${selectedVariation?.id === variation.id
                ? `${isCompact || isMobile ? 'bg-gray-200 text-gray-800' : 'bg-white/50'}`
                : `${isCompact || isMobile ? 'text-gray-800' : 'text-white'}`
              }`}
            onClick={() => setSelectedVariation(variation)}
            initial={{
              opacity: 0.5,
              backgroundColor: 'rgba(255, 255, 255, 0)',
            }}
            style={{
              color: `${selectedVariation?.id === variation.id
                ? studioStore?.settings?.colors?.primary_color
                : isCompact || isMobile ? '#4A4A4A' : '#ffffff'
              }`,
            }}
            animate={{
              backgroundColor: selectedVariation?.id === variation.id
                ? isCompact || isMobile ? '#e0e0e0' : 'rgba(255, 255, 255, 0.6)'
                : 'rgba(255, 255, 255, 0)',
              opacity: 1,
            }}
            transition={{ duration: 0.3 }}
          >
            {variation?.attributes?.map(attr => decodeURIComponent(attr.option)).join(' / ')}
          </motion.button>
        ))}
      </div>
    </div>
  );
});

export default VariationToggle;
